// extracted by mini-css-extract-plugin
export const form = "X_t";
export const input = "X_g";
export const errorMsg = "X_m";
export const btnUpdate = "X_w";
export const title = "X_x";
export const profileSection = "X_z";
export const passwordTitle = "X_C";
export const cropper = "X_bp";